import React from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { logErrors } from "./components/api/LogErrorsAPI";

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error) {
      logErrors(error);
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
